import { render } from "./appCenter.vue?vue&type=template&id=5bcc3f2f"
import script from "./appCenter.vue?vue&type=script&lang=js"
export * from "./appCenter.vue?vue&type=script&lang=js"

import "./appCenter.vue?vue&type=style&index=0&id=5bcc3f2f&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__